import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid'; // For generating unique device token
import axios from 'axios';
import { useAuth } from '../AuthContext'; // Ensure the path is correct
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "../Components/Login.css"; // Custom CSS file for styles
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // For eye icon toggle

import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput
} from 'mdb-react-ui-kit';
import Loader from '../Components/Loader';
import { BASE_URL } from '../config';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth(); // Get the login function from context

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [deviceToken] = useState(uuidv4()); // Generate a unique device token on initialization
  const [os, setOs] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const [loading, setLoading] = useState(false); // State to manage loading state

  useEffect(() => {
    const detectOSAndDevice = () => {
      const userAgent = window.navigator.userAgent;
      const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;

      let os = 'Unknown OS';
      let deviceName = 'Unknown Device';

      if (['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(platform)) {
        os = 'Mac OS';
        deviceName = platform;
      } else if (['iPhone', 'iPad', 'iPod'].includes(platform)) {
        os = 'iOS';
        deviceName = platform;
      } else if (['Win32', 'Win64', 'Windows', 'WinCE'].includes(platform)) {
        os = 'Windows';
        deviceName = platform;
      } else if (/Android/.test(userAgent)) {
        os = 'Android';
        deviceName = 'Android Device';
      } else if (/Linux/.test(platform)) {
        os = 'Linux';
        deviceName = 'Linux Device';
      }

      return { os, deviceName };
    };

    const { os, deviceName } = detectOSAndDevice();
    setOs(os);
    setDeviceName(deviceName);
  }, []);

  const handleLogin = async () => {
    if (!username || !password) {
      alert('Please fill in both fields');
      return;
    }

    setLoading(true); // Set loading state to true when login starts
    try {
      const response = await axios.post(`${BASE_URL}Login`, {
        Email: username,
        Password: password, // Note the casing; it should match the API's expected parameter
        OS: os,
        DeviceToken: deviceToken,
        DeviceName: deviceName
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (response.data.ResponseCode === "0000") {
        setLoading(false); // Set loading state to false when login is successful
        const userData = response.data;
        sessionStorage.setItem("user", JSON.stringify(userData));
        login(userData); // Call the login method from context

        navigate(`/Dashboard/${userData.UserId}`);
      } else {
        setLoading(false); // Set loading state to false if login fails
        alert(response.data.Message);
      }
    } catch (error) {
      setLoading(false); // Set loading state to false if an error occurs
      console.error('Login error:', error);
      alert('An error occurred during login. Please try again.');
    }
  };

  const handleRegisterClick = () => {
    // navigate('/Register');
    navigate('/Register_Doctor'); // New Form

  };

  const handleForgotPassword = () => {
    navigate('/ForgotPassword');
  };

  return (
    <MDBContainer className=" mt-3">
      {
        loading && <Loader />
      }
      <MDBRow >
        <div className="text-center mb-3">
          <img src="/logob.png" style={{ width: '185px' }} alt="logo" />
        </div>
        <MDBCol size="lg" className='order-2 order-lg-1'>
          <div className="d-flex flex-column">
            <div className="text-center mt-3">
              {/* <h4 className="mt-1 mb-2 pb-1">Login to your account</h4> */}
            </div>

            <p className='mt-5'>Please login to your account</p>
            <MDBInput
              wrapperClass='mb-2'
              label='Email address'
              id='form1'
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <div className="position-relative">
              <MDBInput
                wrapperClass="mb-4"
                label="Password"
                id="form2"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <MDBBtn
                type="button"
                className="password-toggle-btn position-absolute top-50 end-0 p-0 border-0 bg-transparent mr-2"
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  zIndex: 1,
                  transform: 'translateY(-100%)', // This will vertically center the icon
                }}
              >
                {showPassword ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
              </MDBBtn>
            </div>


            <div className="text-center pt-1 mb-5 pb-1">
              <MDBBtn className="mb-4 w-100 btn_primary" type="button" onClick={handleLogin}>Sign in</MDBBtn>
              <a className="text-muted" type='button' onClick={handleForgotPassword}>Forgot password?</a>
            </div>

            <div className="d-flex flex-row flex-wrap align-items-center justify-content-center pb-4 mb-4">
              <p className="mb-0">Don't have an account?</p>
              <MDBBtn className='mx-2 btn_primary' onClick={handleRegisterClick}>
                Register as Doctor
              </MDBBtn>
            </div>
          </div>
        </MDBCol>

        <MDBCol size="lg" className='order-1 order-lg-2'>
          <div className="d-flex flex-column justify-content-center h-100 mb-2" style={{ backgroundColor: '#50c4cc' }}>
            <div className="text-white px-3 py-4 mx-md-4">
              <h4 className="mb-4">Welcome to WEBDOC as a Specialist Doctor</h4>
              <p className="small mb-0">We are thrilled to have you join us as a Specialist Doctor and to embark on this journey to revolutionize healthcare together. Through our platform, you’ll have the opportunity to connect with patients across Pakistan, delivering expert care via convenient audio and video tele-consultations.
                <br /><br />
                As part of the WEBDOC community, you’ll be at the forefront of transforming healthcare accessibility and impact. Thank you for joining us in making a difference.
              </p>
            </div>
          </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default Login;
